module.exports = __webpack_public_path__ + "index.html";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader?name=index.html!../example/index.html
// module id = 608
// module chunks = 0